module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "elevation-0"
  }, [_c('vuex-loader', {
    attrs: {
      "request-id": _vm.reqId
    }
  }), _vm._v(" "), _c('v-card-title', {
    staticClass: "overline"
  }, [_vm._v("\n      Are you sure you want to delete this appointment?\n    ")]), _vm._v(" "), _c('v-card-text', [_c('v-alert', {
    attrs: {
      "type": "warning",
      "warning": "",
      "value": true
    }
  }, [_vm._v("This will permanently delete this appointment")]), _vm._v(" "), _c('v-list', {
    attrs: {
      "three-line": ""
    }
  }, [_c('v-subheader', {
    staticClass: "overline"
  }, [_vm._v("Appointment details:")]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('appointment-list-item', {
    attrs: {
      "with-action": false,
      "appointment": _vm.appointment
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('vuex-btn', {
    attrs: {
      "is-disabled": !_vm.appointment.id,
      "reqId": _vm.reqId,
      "text": "Delete appointment"
    },
    on: {
      "save": _vm.save
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a362de9e","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/appointment/edit/Delete.vue
// module id = 1505
// module chunks = 9